import React, { useState, useEffect, useRef } from 'react';
import {
    Card,
    CardContent,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination
} from '@mui/material';
import Top3 from '../../Dashboard/components/Top3';
import CustomDateRangePicker from '../../Dashboard/components/CustomDateRangePicker';
import { useContent } from '../../../../context/ContentContext';
import format from 'date-fns/format';
import subYears from 'date-fns/subYears';

const TopThreeDisplay = () => {
    const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });
    const { fetchTopAgentData, topAgentData, fetchDownlineData, DownlineData } = useContent();
    console.log(topAgentData); // Check the topAgentData response
    console.log(DownlineData);

    const isFirstRender = useRef(true);

    const formatCurrency = (value) => `Rp. ${new Intl.NumberFormat('id-ID').format(value || 0)}`;

    const handleDateChange = ({ startDate, endDate }) => {
        if (!startDate || !endDate) {
            console.error("Start date and end date are required.");
            return;
        }

        try {
            const formattedStartDate = format(new Date(startDate), 'yyyy-MM-dd');
            const formattedEndDate = format(new Date(endDate), 'yyyy-MM-dd');

            setDateRange({ startDate: formattedStartDate, endDate: formattedEndDate });
        } catch (error) {
            console.error("Error formatting dates:", error);
        }
    };

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            const defaultStartDate = subYears(new Date(), 4);
            const defaultEndDate = new Date();

            handleDateChange({
                startDate: format(defaultStartDate, 'yyyy-MM-dd'),
                endDate: format(defaultEndDate, 'yyyy-MM-dd'),
            });
        }
    }, []);

    useEffect(() => {
        if (dateRange.startDate && dateRange.endDate) {
            fetchTopAgentData(dateRange.startDate, dateRange.endDate);
            fetchDownlineData(dateRange.startDate, dateRange.endDate);
        }
    }, [dateRange]);

    const data = DownlineData || []; // Fallback to empty array if no data available

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const paginatedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Stack spacing={2}>
            <Card sx={{ padding: 2, backgroundColor: '#f3f4f6' }}>
                <CardContent>
                    <Top3 dateRange={dateRange} topAgentData={topAgentData} />
                </CardContent>
            </Card>

            <Card sx={{ padding: 2, backgroundColor: '#e3f2fd' }}>
                <CardContent>
                    <CustomDateRangePicker onDateChange={handleDateChange} />
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{
                            color: '#1976d2',
                            fontSize: '0.75rem',
                            '& .MuiTablePagination-selectLabel': { fontSize: '0.75rem' },
                            '& .MuiTablePagination-select': { fontSize: '0.75rem', marginX: 0 },
                            '& .MuiTablePagination-toolbar': { paddingX: 0 },
                            '& .MuiTablePagination-actions': { marginX: 0 },
                        }}
                    />
                    <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
                        <Table stickyHeader>
                            <TableHead sx={{ backgroundColor: '#1976d2' }}>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Peringkat</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Agen</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Total Pendapatan</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paginatedData.map((item, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{
                                            backgroundColor: index % 2 === 0 ? '#f1f8e9' : '#e3f2fd',
                                            '&:hover': { backgroundColor: '#e1f5fe' },
                                        }}
                                    >
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{item.name}</TableCell>
                                        <TableCell>{formatCurrency(item.total_income)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CardContent>
            </Card>
        </Stack>
    );
};

export default TopThreeDisplay;
